import { useContext } from 'react';

import { SetWillRedirectOnLoadContext } from '../will-redirect-on-load-contexts';

export const useSetWillRedirectOnLoad = () => useContext(SetWillRedirectOnLoadContext);
